import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { NzModalService } from 'ng-zorro-antd';
import * as _ from 'lodash';

import { TranslateService } from '@ngx-translate/core';
import { RoleManageService } from '../../../../manage/services/roleManage.service';
import { UserManageService } from '../../../../manage/services/userManage.service';
import { UserService } from '../../../../core/services/user.service';
import { UtilService } from '../../../../core/services/util.service';
import { UserInfoService } from '../../../services/user-info.service';
@Component({
  selector: 'app-userInfo',
  templateUrl: './userInfo.component.html',
  styleUrls: ['./userInfo.component.css']
})
export class UserInfoComponent implements OnInit {
  userForm: FormGroup;
  ents: Array<any>;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private fb: FormBuilder,
    private userInfoService: UserInfoService,
    private userService: UserService,
    private modal: NzModalService,
    private util: UtilService,
    private translate: TranslateService
  ) {
    // create form
    this.userForm = this.fb.group({ // <-- the parent FormGroup
      name: ['', [Validators.required, Validators.maxLength(50)]],
      email: ['', [Validators.required, this.emailValidator]],
      mobile: ['', this.mobileValidator],
      phone: ['', this.telValidator],
      ent: ['', Validators.required],
      site: [''],
      remarks: ['']
    });
  }

  get userInfo() {
    const userInfo = sessionStorage.getItem('userInfo');
    if (userInfo !== null) {
      return JSON.parse(userInfo);
    }
    return null;
  }

  set userInfo(data) {
    const userInfo = sessionStorage.getItem('userInfo');
    if (userInfo !== null) {
      let user = JSON.parse(userInfo);
      for (let x in data) {
        user[x] = data[x];
      }
      sessionStorage.setItem('userInfo', JSON.stringify(user));
    }
  }

  ngOnInit() {
    this.setForm(this.userInfo);

    this.userService.getUserEntList().toPromise().then(res => {
      this.ents = res.listdata;
    });
  }

  setForm(val) {
    this.userForm.patchValue({
      name: val.name,
      email: val.email,
      mobile: val.mobile,
      phone: val.phone,
      ent: val.ent,
      site: val.site,
      remarks: val.remarks
    });
  }

  emailValidator = (control: FormControl): { [s: string]: boolean } => {
    if (control.value && !control.value.match(/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/)) {
      return { format: true, error: true };
    }
  }
  mobileValidator = (control: FormControl): { [s: string]: boolean } => {
    if (control.value && !control.value.match(/^(13|14|15|17|18|19)[0-9]{9}$/)) {
      return { format: true, error: true };
    }
  }
  telValidator = (control: FormControl): { [s: string]: boolean } => {
    if (control.value && !control.value.match(/^(0\d{2}-\d{8}(-\d{1,4})?)|(0\d{3}-\d{7,8}(-\d{1,4})?)$/)) {
      return { format: true, error: true };
    }
  }
  onSubmit() {
    this.userForm.markAsDirty();
    for (const key in this.userForm.controls) {
      if (this.userForm.controls.hasOwnProperty(key)) {
        this.userForm.controls[key].markAsDirty();
      }
    }
    if (this.userForm.valid) {
      const val = this.userForm.value;
      const body = {
        name: val.name,
        email: val.email,
        mobile: val.mobile,
        phone: val.phone,
        ent: val.ent,
        site: val.site,
        remarks: val.remarks
      };

      // 发送请求,成功后跳转
      this.userInfoService.modifyInfo(body).toPromise().then(res => {
        this.userInfo = body;
        this.modal.success({
          title: this.translate.instant('common.success'),
          content: this.translate.instant('user.modify-info-success')
        }).on('onHidden', () => {
          setTimeout(() => {
            this.router.navigate(['/user']);
          }, 300);
        });
      }, err => {
        this.modal.error({
          title: this.translate.instant('common.error'),
          content: err
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/userCenter/userInfo/userInfo.component.ts